// Lógica pura de la contabilización diaria (la pantalla vive en
// ContabilizacionDiaria.jsx).

export const PROGRAMA_CONTABILIZACION_DIARIA = 'contabilizaciondiaria';

export const ESTADO_DIA = {
  pendiente: { etiqueta: 'Pendiente', tono: 'aviso' },
  novedades: { etiqueta: 'Novedades', tono: 'aviso' },
  enviado: { etiqueta: 'Enviado', tono: 'ok' },
  sinmovimientos: { etiqueta: 'Sin movimientos', tono: 'neutro' },
};

export const SEMAFORO_PROPUESTA = {
  listo: { etiqueta: 'Listo', tono: 'ok' },
  configuracion: { etiqueta: 'Falta configuración', tono: 'error' },
  mescerrado: { etiqueta: 'Mes cerrado', tono: 'error' },
};

export const fmtMoney = (v) =>
  (Number(v) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Solo lo que está listo se envía; lo demás se queda en la pre-vista. */
export function resumenPrevista(propuestas) {
  const lista = propuestas || [];
  const listas = lista.filter((p) => p.semaforo === 'listo');
  return {
    total: lista.length,
    listos: listas.length,
    conProblema: lista.length - listas.length,
    montoListos: Math.round(listas.reduce((s, p) => s + (Number(p.debito) || 0), 0) * 100) / 100,
  };
}

export function agruparPorTipo(propuestas) {
  const grupos = new Map();
  (propuestas || []).forEach((p) => {
    const g = grupos.get(p.tipo) || { tipo: p.tipo, propuestas: [], total: 0 };
    g.propuestas.push(p);
    g.total = Math.round((g.total + (Number(p.debito) || 0)) * 100) / 100;
    grupos.set(p.tipo, g);
  });
  return [...grupos.values()];
}
